import React from 'react';

import CliveMarkdownDisplay from '~/components/Clive/CliveMarkdownDisplay/CliveMarkdownDisplay';
import { Heading } from '~/components/core';
import Text from '~/components/core/TextComponents/Text';

import SopProcessingLoader from './SopProcessingLoader';
import type { SopTocStepProps } from './types';

const SopTocStep: React.FC<SopTocStepProps> = ({ toc_markdown, isLoading }) => {
  // Show loading state during TOC generation
  if (isLoading) {
    return <SopProcessingLoader />;
  }

  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-col gap-2">
        <Heading variant={Heading.TYPES.H2} colorVariant={Heading.COLOR_VARIANTS.PRIMARY}>
          Review Table of Content
        </Heading>
        <Text variant={Text.VARIANTS.SM} colorVariant={Text.COLOR_VARIANTS.SECONDARY}>
          Review the final table of contents generated from your uploaded SOP. To change the table of content, SOP
          content extraction must be edited accordingly.
        </Text>
      </div>

      <div className="max-h-[440px] w-full overflow-y-auto rounded-lg border border-solid border-slate-300 px-4">
        <CliveMarkdownDisplay content={toc_markdown} />
      </div>
    </div>
  );
};

export default SopTocStep;
